import gql from "graphql-tag";

export default gql`
  mutation ($input: CreatePermitPortalUserInput!) {
    admin_createPermitPortalUser(input: $input) {
      id
    }
  }
`;
